import { render, staticRenderFns } from "./BlogsList.vue?vue&type=template&id=5239417e&scoped=true&"
import script from "./BlogsList.vue?vue&type=script&lang=js&"
export * from "./BlogsList.vue?vue&type=script&lang=js&"
import style0 from "./BlogsList.vue?vue&type=style&index=0&id=5239417e&lang=scss&scoped=true&"
import style1 from "./BlogsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5239417e",
  null
  
)

export default component.exports